module.exports = __webpack_public_path__ + "static/media/ms.32d9a0f2.svg";